import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import {Edit as EditIcon, Delete as DeleteIcon, SubdirectoryArrowRight as ViewIcon} from '@material-ui/icons';
import {isEmpty} from 'lodash/lang';
import {withGreatListingWrapper, GreatTableCore, SortingManager, DeletionConfirm} from './index';
import {I18nContext} from 'contexts/i18n';

export const getGreatTable = (ExtraFilters) =>
  withStyles({
    cursorPointer: {
      cursor: 'pointer',
    },
    tableCellNoWrap: {
      whiteSpace: 'nowrap',
    },
  })(
    withGreatListingWrapper(
      class extends React.Component {
        static contextType = I18nContext;
        static propTypes = {
          classes: PropTypes.object.isRequired,
          recordPages: PropTypes.object.isRequired,
          refreshTable: PropTypes.func.isRequired,
          onSortableFieldSet: PropTypes.func.isRequired,
          hiddenFields: PropTypes.array,
          itemName: PropTypes.string.isRequired,
          getFieldsMapping: PropTypes.func.isRequired,
          getFieldsSettings: PropTypes.func.isRequired,
          onDeleteActionClick: PropTypes.func,
          showUpdateModal: PropTypes.func,
          openViewModal: PropTypes.func,
          getRowsSettings: PropTypes.func,
        };

        constructor(props) {
          super(props);
          this.showDeletionConfirm = this.showDeletionConfirm.bind(this);
          this.buildRecords = this.buildRecords.bind(this);
          this.buildFieldsSettings = this.buildFieldsSettings.bind(this);
          this.buildRowsSettings = this.buildRowsSettings.bind(this);
          this.sortingManager = new SortingManager();
          this.deletionConfirmBoxRef = React.createRef();
        }

        showDeletionConfirm(record) {
          this.setState(
            {
              recordToRemove: record,
            },
            this.deletionConfirmBoxRef.current.openModal,
          );
        }

        buildRecords(records) {
          const {getFieldsMapping} = this.props;
          const sortedIds = records.sortedIds || [];
          return isEmpty(sortedIds)
            ? []
            : sortedIds.map((recordId) => {
                const record = records[recordId];
                return {
                  record,
                  id: record.id,
                  ...getFieldsMapping(record),
                  actions: '',
                };
              });
        }

        buildFieldsSettings({classes, ...args}) {
          const {i18nTranslate} = this.context;
          const {getFieldsSettings} = this.props;
          const fieldsSettings = getFieldsSettings(args);
          if (!fieldsSettings.actions) {
            fieldsSettings.actions = {
              fieldText: i18nTranslate`Actions`,
              formatData: (cell, row, restProps) => (
                <span className="table-actions">
                  {restProps.openViewModal && (
                    <ViewIcon className={classes.cursorPointer} onClick={() => restProps.openViewModal(row.record)} />
                  )}
                  {restProps.showUpdateModal && (
                    <EditIcon className={classes.cursorPointer} onClick={() => restProps.showUpdateModal(row.record)} />
                  )}
                  {restProps.canDelete && (
                    <DeleteIcon className={classes.cursorPointer} onClick={() => restProps.showDeletionConfirm(row)} />
                  )}
                </span>
              ),
              headerCellClassName: classes.tableCellNoWrap,
            };
          }
          return fieldsSettings;
        }

        buildRowsSettings(records) {
          const {getRowsSettings} = this.props;
          const sortedIds = records.sortedIds || [];
          return isEmpty(sortedIds) || !getRowsSettings
            ? {}
            : sortedIds.reduce((rowsSettings, recordId) => {
                const record = records[recordId];
                rowsSettings[recordId] = getRowsSettings(record);
                return rowsSettings;
              }, {});
        }

        render() {
          const {
            classes,
            recordPages,
            refreshTable,
            onSortableFieldSet,
            hiddenFields,
            onDeleteActionClick,
            showUpdateModal,
            openViewModal,
            itemName,
            ...restProps
          } = this.props;
          const canDelete = !!onDeleteActionClick;
          const recordPage = recordPages[recordPages.currentPage] || {};
          return (
            <React.Fragment>
              {onDeleteActionClick && (
                <DeletionConfirm
                  ref={this.deletionConfirmBoxRef}
                  itemName={itemName}
                  deleteAction={() => onDeleteActionClick(this.state.recordToRemove)}
                  DeleteButton="span"
                />
              )}
              <GreatTableCore
                {...{
                  records: this.buildRecords(recordPage),
                  fieldsSettings: this.buildFieldsSettings({refreshTable, classes}),
                  rowsSettings: this.buildRowsSettings(recordPage),
                  sortingManager: this.sortingManager,
                  onSortableFieldSet,
                  hiddenFields,
                  showDeletionConfirm: this.showDeletionConfirm,
                  showUpdateModal,
                  openViewModal,
                  canDelete,
                  ...restProps,
                }}
              />
            </React.Fragment>
          );
        }
      },
      ExtraFilters,
    ),
  );

export default getGreatTable();
